import { render } from "./Payments.vue?vue&type=template&id=3b683cea&scoped=true&ts=true&lang=pug"
import script from "./Payments.vue?vue&type=script&lang=ts&setup=true"
export * from "./Payments.vue?vue&type=script&lang=ts&setup=true"

import "./Payments.vue?vue&type=style&index=0&id=3b683cea&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b683cea"]])

export default __exports__